import type { SidebarMenuTab } from '@/shared/model/SidebarStore';
import { NAV_COLORS } from '@/shared/ui/components/SideMenus/navPalette';
import { Tab, Tabs } from '@mui/material';

type Props = {
  value: SidebarMenuTab;
  onChange: (value: SidebarMenuTab) => void;
};

/**
 * Two menus share one pane while a patient is open: the chart's own links, and the rest of the
 * portal.  Before this, opening a patient replaced the navigation wholesale and the only way back
 * to Care Management or Reports was the icon rail.
 *
 * The tabs appear only with a patient in context — there is no second menu to switch to
 * otherwise — and the patient's own tab leads, since that is why the chart is open.
 */
const SidebarMenuTabs = ({ value, onChange }: Props) => (
  <Tabs
    value={value}
    onChange={(_event, next: SidebarMenuTab) => onChange(next)}
    variant="fullWidth"
    sx={{
      minHeight: 36,
      borderBottom: `1px solid rgba(255, 255, 255, 0.14)`,
      '& .MuiTab-root': {
        minHeight: 36,
        paddingY: 0.5,
        fontSize: 12.5,
        fontWeight: 600,
        textTransform: 'none',
        color: NAV_COLORS.onDarkMuted,
        '&.Mui-selected': { color: NAV_COLORS.onDark }
      },
      '& .MuiTabs-indicator': { backgroundColor: NAV_COLORS.inkIcon, height: 3 }
    }}
  >
    <Tab value="patient" label="This Patient" />
    <Tab value="main" label="Main" />
  </Tabs>
);

export default SidebarMenuTabs;
